import { Dispatch, useMemo } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { SettingsActions } from './actionTypes';
import Dispatcher from './dispatcher';
import selector from './selector';

const useSettings = () => {
    const dispatch = useDispatch<Dispatch<SettingsActions>>();
    const dispatcher = useMemo(()=>new Dispatcher(dispatch), [dispatch]);
    const state = useSelector(selector, shallowEqual);

    return { state, dispatcher };
}

export default useSettings;
